import { useEffect, useState } from "react";
import Lenis from "lenis";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import CycleSection from "../components/CycleSection";
import PepeSection from "../components/PepeSection";
import PacksSection from "../components/PacksSection";
import EngagementsSection from "../components/EngagementsSection";
import DemoFormSection from "../components/DemoFormSection";
import Footer from "../components/Footer";
import GiuliaChat from "../components/GiuliaChat";
import { scrollToId } from "../components/Nav";

export default function Landing() {
  const [pack, setPack] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const handleSelectPack = (name) => {
    setPack(name);
    setTimeout(() => scrollToId("demo"), 60);
  };

  return (
    <main>
      <Nav />
      <Hero />
      <Marquee />
      <CycleSection />
      <PepeSection />
      <PacksSection onSelectPack={handleSelectPack} />
      <EngagementsSection />
      <DemoFormSection pack={pack} setPack={setPack} />
      <Footer />
      <GiuliaChat />
    </main>
  );
}
